let dt_index = null;
let microsite_id = null;
let comment_id = null;

export function index(params){

    dt_index = $('#comments_table').DataTable({
        ajax: {
            url: $('#comments_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_comments_actions },
            { width: '120', data: 'created_at', orderable: true, searchable: true, render: datatables.render_datetime },
            { data: 'author_id', orderable: true, searchable: true },
            { data: 'content_id', orderable: true, searchable: true },
        ],
        order: [[2, 'desc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_comments"]').click(batch_delete_comments);
    });

    microsite_id = params.microsite_id;
}

function render_comments_actions(data, type, row){

    const url_info = ($("#comments_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

//show

export function show(params){

    microsite_id = params.microsite_id;
    comment_id = params.comment_id;
}


export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

function batch_delete_comments(params){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.comments.batch_delete'].replace('{microsite}', microsite_id);
    
    let comments_id = [];
    $.each(rows_selected, function(index, rowId){
        comments_id.push(rowId);
    });
    
    if(comments_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna comentario'));

    } else {

        const title = __('Eliminar comentarios');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un comentario.|[2,*] Estás a punto de eliminar :count comentarios.', comments_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let comment_id of comments_id){
                        formData.append('comments_id[]', comment_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}